import { Environment } from '@celito.clients/singleton';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const envName = String(
  Environment.getInstance().getParam('NX_ENV_NAME') ?? 'local'
);

// ✅ GOOD: Shared warning state - syncs across tabs when warning shows/hides
export const showWarningAtom = atomWithStorage<boolean>(
  `session-warning-${envName}`,
  false,
  createJSONStorage<boolean>(() => localStorage),
  { getOnInit: true }
);

// ✅ GOOD: Shared end time - all tabs calculate countdown from this
export const endTimeAtom = atomWithStorage<number | null>(
  `session-endtime-${envName}`,
  null,
  createJSONStorage<number | null>(() => localStorage),
  { getOnInit: true }
);

// ✅ GOOD: Master tab coordination - synced across tabs via localStorage
export const masterTabIdAtom = atomWithStorage<string | null>(
  `session-master-tab-${envName}`,
  null,
  createJSONStorage<string | null>(() => localStorage),
  { getOnInit: true }
);

// ✅ GOOD: Master heartbeat for health checks
export const masterHeartbeatAtom = atomWithStorage<number | null>(
  `session-master-heartbeat-${envName}`,
  null,
  createJSONStorage<number | null>(() => localStorage),
  { getOnInit: true }
);

// ❌ REMOVED: countdownAtom
// Reason: Each tab calculates its own countdown locally from endTimeAtom
// This avoids localStorage sync delays and race conditions
// Countdown is now local state: useState(SessionConstants.COUNTDOWN_SECONDS)
